// useIntlを呼び出せない箇所からintlのメッセージを取得する

import en from "../intl/en.json"
import ko from "../intl/ko.json"
import zhCn from "../intl/zh-cn.json"
import zhTw from "../intl/zh-tw.json"
import {IntlShape} from "react-intl";

const getValueByNestedKey = (obj, key): string => {
    return key.split('.').reduce((o, k) => (o || {})[k], obj);
};

export const getIntlMessage = (locale: string, path: string): string => {
    const intl = locale === "en" ? en :
        locale === "zh-cn" ? zhCn :
            locale === "zh-tw" ? zhTw :
                locale === "ko" ? ko : null;
    if (!intl) {
        console.error(`missmatched locale: ${locale}`);
    }

    return getValueByNestedKey(intl, path);
}

export const getMicroCMSCategoryIntl = ({intl, categoryName}: { intl: IntlShape, categoryName: string }) => {
    switch (categoryName) {
        case "宿泊":
            return intl.formatMessage({id: "common.accommodation"});
        case "レストラン&バー":
            return intl.formatMessage({id: "dining.title"});
        case "ウエディング":
            return intl.formatMessage({id: "common.wedding"});
        case "宴会・会議":
            return intl.formatMessage({id: "pageTitles./meetings-events/"});
        case "イベント":
            return intl.formatMessage({id: "meetingsEvents.chooseOurEvents.title"});
        case "館内施設":
            return intl.formatMessage({id: "common.facilities"});
        case "その他":
            return intl.formatMessage({id: "common.others"});
        default:
            return categoryName;
    }
}